import { DataFrame } from "dataframe-js";
import moment from "moment";
import {
    QUOTE_GET,
} from '@/data/url';
import config from '@/services/config'
import { unwrapApiData } from '@/services/apiEnvelope'

const generateQuoteCSV = (quoteData) => {
    let flatData = Array.isArray(quoteData[0]) ? quoteData[0] : quoteData;

    let df = new DataFrame(flatData);

    // Add columns
    df = df
        .withColumn("Line Item", (_, index) => index + 1)
        .withColumn("ext_cost", (row) => row.get("unit_cost") * row.get("quantity"));

    // Select columns
    df = df.select(
        "Line Item",
        "customer",
        "quote_type",
        "part_number",
        "part_quoted",
        "description",
        "quantity",
        "unit_of_measure",
        "quote",
        "ext_quote",
        "lead_time",
        "notes",
        "no_quote",
        "vendor",
        "unit_cost",
        "ext_cost"
    );

    // Format the "no_quote" field
    df = df.map((row) => {
        const val = row.get("no_quote");
        return row.set("no_quote", val ? "NO QUOTE" : "");
    });

    // Rename columns
    df = df
        .rename("customer", "Customer")
        .rename("quote_type", "Quote Type")
        .rename("part_number", "Part Number")
        .rename("part_quoted", "Part Quoted")
        .rename("description", "Description")
        .rename("quantity", "Quantity")
        .rename("unit_of_measure", "UOM")
        .rename("quote", "Quote")
        .rename("ext_quote", "Ext Quote")
        .rename("lead_time", "Lead Time (Days)")
        .rename("notes", "Notes")
        .rename("vendor", "Vendor")
        .rename("no_quote", "No Quote")
        .rename("unit_cost", "Unit Cost")
        .rename("ext_cost", "Ext Cost");

    // Convert to CSV
    return df.toCSV();
}

const getQuoteCSVBySearchId = async (searchActionId) => {
    const sessionToken = config.sessionToken;
    const parsedSearchActionId = parseInt(searchActionId, 10)
    const url = `${config.backendURL}${QUOTE_GET}/${parsedSearchActionId}`
    const response = await fetch(url, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${sessionToken}`,
            'Content-Type': 'application/json',
        },
    });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }

    const body = await response.json()
    return unwrapApiData(body, [])
}

const sanitizeFileNamePart = (value) => {
    if (value === null || value === undefined) {
        return ''
    }

    return String(value)
        .trim()
        .replace(/[<>:"/\\|?*]/g, '_')
        .replace(/_+/g, '_')
        .replace(/^[._]+|[._]+$/g, '')
}

const buildQuoteDownloadFileName = ({
    date = moment().format("YYYY-MM-DD"),
    prefix = '',
    searchActionId = '',
    quoteType = '',
    customer = '',
    customerReference = '',
} = {}) => {
    const segments = [
        prefix,
        prefix ? searchActionId : '',
        date,
        quoteType,
        customer,
        customerReference,
    ]
        .map(sanitizeFileNamePart)
        .filter(Boolean)

    return `${segments.length > 0 ? segments.join('_') : 'quote'}.csv`
}

const downloadCSV = (csvContent, formData, fileName = null) => {
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    if (!fileName) {
        fileName = buildQuoteDownloadFileName({
            quoteType: formData?.search_type,
            customer: formData?.search_customer,
            customerReference: formData?.search_reference,
        })
    }

    // Create a temporary download link
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;

    // Trigger the download
    link.click();

    // Release the object URL after download
    URL.revokeObjectURL(url);
}

export default {
    generateQuoteCSV,
    downloadCSV,
    getQuoteCSVBySearchId,
    buildQuoteDownloadFileName,
}
